import React from 'react';
import './account.scss';
import AccountShow from './accountShow';
import { MoonLoader } from 'react-spinners';


const Account = ({accounts, followingList}) => {

  if (!accounts) {
    return (
      <div className='followers-list center'  > 
        <MoonLoader size={15} />
      </div>
    );
  } 

  if (accounts.length === 0) {
    return (
      <div className='followers-list' >
        <span>Empty List</span>
      </div>
    );
  }
  
  return ( 
    <div className='account' >
      {
        accounts.map(account => (
        <AccountShow key={account._id} account={account} followingList={followingList} />
        )) 
      }
    </div> 
  )
}


export default Account;